<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'AnalyticComponent.vue'
}
</script>

<style scoped></style>
